import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '@/components/Sidebar';
import { Header } from '@/components/Header';
import { AIAssistantPanel, AIAssistantButton } from '@/components/ai-assistant';

// Routes that need full-screen layout without padding
const fullScreenRoutes = [
  '/workflows/',
  '/data/',
  '/forms/',
];

export function RootLayout() {
  const location = useLocation();

  // Check if current route is a full-screen designer page (detail pages like /workflows/:id)
  const isFullScreenRoute = fullScreenRoutes.some(
    (route) => location.pathname.startsWith(route) && location.pathname !== route.slice(0, -1)
  );

  return (
    <div className="flex min-h-screen bg-secondary-50 dark:bg-secondary-950">
      {/* Skip link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:m-4 focus:rounded-lg focus:bg-primary-500 focus:px-4 focus:py-2 focus:text-white focus:outline-none"
      >
        Skip to main content
      </a>

      {/* Sidebar - hidden on mobile, visible on lg+ */}
      <Sidebar className="hidden lg:flex" />

      {/* Main content area */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main
          id="main-content"
          className={`flex-1 overflow-y-auto ${isFullScreenRoute ? '' : 'p-4 sm:p-6'}`}
          role="main"
          tabIndex={-1}
        >
          <Outlet />
        </main>
      </div>

      {/* Mobile sidebar (overlay) */}
      <Sidebar className="lg:hidden" />

      {/* AI Assistant */}
      <AIAssistantPanel />
      <AIAssistantButton />
    </div>
  );
}
